<template>
    <right-filter-drawer
        v-model="showFilterDrawer"
        :title="title"
        :disable-apply="isFiltersEmpty || !isFormValid"
        :disable-clear="isFiltersEmpty"
        @cancel="onCancelFilters"
        @apply="onApplyFilters"
        @clear="onClearFilters"
    >
        <template v-slot:content>
            <v-form ref="form" v-model="isFormValid">
                <form-generator
                    v-model="localFilters"
                    :schema="schema"
                    value-class=""
                ></form-generator>
            </v-form>
        </template>
    </right-filter-drawer>
</template>

<script>
import FormLayout from '@/components/FormLayout/VerticalFormLayout';
import HocFormGenerator from '@/components/FormGenerator/HocFormGenerator';
import RightFilterDrawer from '@/components/Drawers/RightFilterDrawer';
import filtersMixin from '@/mixins/filtersDrawerMixin';
import filtersSchema from './filtersSchema';
import { mapState } from 'vuex';

const FormGenerator = HocFormGenerator(FormLayout);

export default {
    name: 'UserFilters',
    components: {
        'form-generator': FormGenerator,
        'right-filter-drawer': RightFilterDrawer
    },
    mixins: [filtersMixin],
    props: {
        filters: {
            type: Object,
            required: false,
            default: () => {}
        },
        title: {
            type: String,
            required: false,
            default: 'User filters'
        },
        allowXocFilter: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            msoFilterOptions: [
                { text: 'MSO users only', value: true },
                { text: 'Non MSO users only', value: false }
            ]
        };
    },
    computed: {
        ...mapState('venue', ['selectedVenue']),
        schema() {
            let updatedSchema = [...filtersSchema];

            const msoFilter = updatedSchema.find(
                item => item.name === 'xocAuth'
            );
            msoFilter.component.props.items = this.msoFilterOptions;
            if (!this.allowXocFilter) {
                updatedSchema = updatedSchema.filter(
                    item => item.name !== 'xocAuth'
                );
            }

            const currentVenueField = updatedSchema.find(
                item => item.name === 'currentVenueOnly'
            );
            const currentVenue = this.selectedVenue.venue.identifier;
            currentVenueField.component.props.label = `Limit to ${currentVenue} users only`;
            return updatedSchema;
        }
    }
};
</script>

<style></style>
